import React, { useEffect } from 'react';
import { X } from 'react-bootstrap-icons';

const ImageViewer = ({ isOpen, onClose, imageSrc, imageAlt }) => {
  // No scroll prevention - let the modal overlay naturally prevent interaction
  // The fixed position modal will stay in place, and we rely on CSS overscroll-behavior
  // This avoids any scroll position issues

  // Handle escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="image-viewer-modal"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.95)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0',
        overflow: 'hidden',
        overscrollBehavior: 'contain' // Prevent scroll chaining without affecting page scroll position
      }}
      onClick={onClose}
      onWheel={(e) => {
        // Prevent wheel events from reaching the page behind
        e.stopPropagation();
      }}
      onTouchMove={(e) => {
        // Prevent touch events from reaching the page behind
        e.stopPropagation();
      }}
    >
      {/* Close button */}
      <button
        onClick={onClose}
        style={{
          position: 'absolute',
          top: '20px',
          right: '20px',
          background: 'rgba(255, 255, 255, 0.1)',
          border: 'none',
          borderRadius: '50%',
          width: '50px',
          height: '50px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          color: 'white',
          fontSize: '24px',
          zIndex: 10000,
          transition: 'background-color 0.2s ease'
        }}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
        }}
        aria-label="Close image viewer"
      >
        <X size={24} />
      </button>

      {/* Image container */}
      <div
        style={{
          width: '95vw',
          height: '95vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '20px'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={imageSrc}
          alt={imageAlt}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            borderRadius: '10px',
            boxShadow: '0 20px 40px rgba(0, 0, 0, 0.5)'
          }}
        />
      </div>
    </div>
  );
};

export default ImageViewer;



